import { render, staticRenderFns } from "./NavigationBlack.vue?vue&type=template&id=a6164ade&scoped=true&"
var script = {}
import style0 from "./NavigationBlack.vue?vue&type=style&index=0&id=a6164ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6164ade",
  null
  
)

export default component.exports